import * as yup from 'yup';
import { Validations } from '../../config';

export const getInputSchema = (text) => {
  const schemaEntries = text.reduce((acc, item) => {
    acc[item.value] = Validations.customText;
    return acc;
  }, {});

  return yup.object().shape(schemaEntries);
};

export const generateValidationSchema = (fields) => {
  const schemaFields = {};
  const maxLengthMap = {};

  fields.forEach((field) => {
    switch (field.value) {
      case 'entity':
        schemaFields[field.value] = yup.string().required('PAN Number is required').matches(/^[A-Za-z0-9]{10}$/, 'PAN Number must be 10 alphanumeric digits');
        maxLengthMap[field.value] = 10;
        break;
      case 'pancard':
        schemaFields[field.value] = yup.string().required('PAN Number is required').matches(/^[A-Za-z0-9]{10}$/, 'PAN Number must be 10 alphanumeric digits');
        maxLengthMap[field.value] = 10;
        break;
      case 'pan':
          schemaFields[field.value] = yup.string().required('PAN Number is required').matches(/^[A-Za-z0-9]{10}$/, 'PAN Number must be 10 alphanumeric digits');
          maxLengthMap[field.value] = 10;
          break;
      case 'pan_number':
        schemaFields[field.value] = yup.string().required('PAN Number is required').matches(/^[A-Za-z0-9]{10}$/, 'PAN Number must be 10 alphanumeric digits');
        maxLengthMap[field.value] = 10;
        break;
      case 'panNumber':
        schemaFields[field.value] = yup.string().required('PAN Number is required').matches(/^[A-Za-z0-9]{10}$/, 'PAN Number must be 10 alphanumeric digits');
        maxLengthMap[field.value] = 10;
        break;
      case 'din_number':
        schemaFields[field.value] = yup.string().required('DIN Number is required').matches(/^[A-Za-z0-9]{10}$/, 'DIN Number must be 20 alphanumeric digits');
        maxLengthMap[field.value] = 20;
        break;
      case 'acc_number':
        schemaFields[field.value] = yup.string().required('Account number is required').matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{5,20}$/, 'Invalid bank account number format. Must be 5 to 20 alphanumeric digits.');
        maxLengthMap[field.value] = 20;
        break;
      case 'ifsc_number':
        schemaFields[field.value] = yup.string().required('IFSC code is required').matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{11}$/, 'Invalid IFSC code format. Must be 11 alphanumeric digits.');
        maxLengthMap[field.value] = 11;
        break;
      case 'ifsc_code':
        schemaFields[field.value] = yup.string().required('IFSC code is required').matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{11}$/, 'Invalid IFSC code format. Must be 11 alphanumeric digits.');
        maxLengthMap[field.value] = 11;
        break;
      case 'pincode1':
        schemaFields[field.value] = yup.string().required('Source Pincode is required').matches(/^[0-9]{6}$/, 'Invalid Source Pincode format. Must be 6 digits.');
        maxLengthMap[field.value] = 6;
        break;
      case 'pincode2':
        schemaFields[field.value] = yup.string().required('Destination Pincode is required').matches(/^[0-9]{6}$/, 'Invalid Destination Pincode format. Must be 6 digits.');
        maxLengthMap[field.value] = 6;
        break;
      case 'dl_number':
        schemaFields[field.value] = yup.string().required('Driving License Number is required').matches(/^[A-Za-z0-9]{5,20}$/, 'Driving License Number must be 5 to 20 alphanumeric digits');
        maxLengthMap[field.value] = 20;
        break;
      case 'epic_number':
        schemaFields[field.value] = yup.string().required('Voter ID Epic number is required').matches(/^[A-Za-z0-9]{5,20}$/, 'Invalid Voter ID Epic number');
        maxLengthMap[field.value] = 20;
        break;
      case 'aadhaar_number':
        schemaFields[field.value] = yup.string().required('Aadhar Number is required').matches(/^[0-9]{12}$/, 'Aadhar Number must be exactly 12 numeric digits')
        maxLengthMap[field.value] = 12;
        break;
      case 'aadhaar':
        schemaFields[field.value] = yup.string().required('Aadhar Number is required').matches(/^[0-9]{12}$/, 'Aadhar Number must be exactly 12 numeric digits')
        maxLengthMap[field.value] = 12;
        break;
      case 'gst_number':
        schemaFields[field.value] = yup.string().required('GST Number is required').matches(/^[A-Za-z0-9]{15}$/, 'GST Number must be 15 alphanumeric digits');
        maxLengthMap[field.value] = 15;
        break;
      case 'gstNumber':
        schemaFields[field.value] = yup.string().required('GST Number is required').matches(/^[A-Za-z0-9]{15}$/, 'GST Number must be 15 alphanumeric digits');
        maxLengthMap[field.value] = 15;
        break;
      case 'gstnumber':
        schemaFields[field.value] = yup.string().required('GST Number is required').matches(/^[A-Za-z0-9]{15}$/, 'GST Number must be 15 alphanumeric digits');
        maxLengthMap[field.value] = 15;
      break;
      case 'gstin':
        schemaFields[field.value] = yup.string().required('GST Number is required').matches(/^[A-Za-z0-9]{15}$/, 'GST Number must be 15 alphanumeric digits');
        maxLengthMap[field.value] = 15;
      break;
      case 'mobile_number':
        schemaFields[field.value] = yup.string().required('Mobile Number is required').matches(/^[0-9]{10}$/, 'Mobile Number must be exactly 10 numeric digits')
        maxLengthMap[field.value] = 10;
        break;
      case 'iec_number':
        schemaFields[field.value] = yup.string().required('ICE Number is required').matches(/^[A-Za-z0-9]{10}$/, 'ICE Number must be 10 alphanumeric digits');
        maxLengthMap[field.value] = 10;
        break;
      case 'vehicleNumber':
        schemaFields[field.value] = yup.string().required('Vehicle Number is required').matches(/^[A-Za-z0-9]{8,12}$/, 'Invalid Vehicle number format. Must be 8 to 12 alphanumeric digits.');
        maxLengthMap[field.value] = 12;
        break;
      case 'vehicle_number':
        schemaFields[field.value] = yup.string().required('Vehicle Number is required').matches(/^[A-Za-z0-9]{8,12}$/, 'Invalid Vehicle number format. Must be 8 to 12 alphanumeric digits.');
        maxLengthMap[field.value] = 12;
        break;
      case 'str1':
        schemaFields[field.value] = yup.string().required('String1 is required').matches(/^[A-Za-z ]{1,100}$/, 'Only alphabets allowed. No numbers or special characters.');
        maxLengthMap[field.value] = 100;
        break;
      case 'str2':
        schemaFields[field.value] = yup.string().required('String2 is required').matches(/^[A-Za-z ]{1,100}$/, 'Only alphabets allowed. No numbers or special characters.');
        maxLengthMap[field.value] = 100;
        break;
      case 'query':
        schemaFields[field.value] = yup.string().required('String2 is required').matches(/^[A-Za-z ]{1,100}$/, 'Only alphabets allowed. No numbers or special characters.');
        maxLengthMap[field.value] = 100;
        break;
      case 'dinNumber':
        schemaFields[field.value] = yup.string().required('DIN Number is required').matches(/^[0-9]{8}$/, 'DIN Number must be 8 digits');
        maxLengthMap[field.value] = 8;
        break;
      case 'reference':
        schemaFields[field.value] = yup.string().required('String1 is required').matches(/^[A-Za-z ]{1,100}$/, 'Only alphabets allowed. No numbers or special characters.');
        maxLengthMap[field.value] = 100;
        break;
      case 'aadhaarNumber':
        schemaFields[field.value] = yup.string().required('Aadhar Number is required').matches(/^[0-9]{12}$/, 'Aadhar Number must be exactly 12 numeric digits')
        maxLengthMap[field.value] = 12;
        break;
      case 'epicNumber':
        schemaFields[field.value] = yup.string().required('Voter ID Epic number is required').matches(/^[A-Za-z0-9]{5,20}$/, 'Invalid Voter ID number format. Must be 5 to 20 alphanumeric digits.');
        maxLengthMap[field.value] = 20;
        break;
      case 'engineNumber':
        schemaFields[field.value] = yup.string().required('Engine number is required').matches(/^[A-Za-z0-9]{5,20}$/, 'Invalid Engine number format. Must be 5 to 20 alphanumeric digits.');
        maxLengthMap[field.value] = 20;
        break;
      case 'chassisNumber':
        schemaFields[field.value] = yup.string().required('Chassis number is required').matches(/^[A-Za-z0-9]{5,20}$/, 'Invalid Chassis number format. Must be 5 to 20 alphanumeric digits.');
        maxLengthMap[field.value] = 20;
        break;
      case 'dlNumber':
        schemaFields[field.value] = yup.string().required('Driving License Number is required').matches(/^[A-Za-z0-9]{5,20}$/, 'Driving License Number must be 5 to 20 alphanumeric digits');
        maxLengthMap[field.value] = 20;
        break;
      case 'distPinCode':
        schemaFields[field.value] = yup.string().required('Destination Pincode is required').matches(/^[0-9]{6}$/, 'Invalid Destination Pincode format. Must be 6 digits.');
        maxLengthMap[field.value] = 6;
        break;
      case 'sourcePinCode':
        schemaFields[field.value] = yup.string().required('Source Pincode is required').matches(/^[0-9]{6}$/, 'Invalid Source Pincode format. Must be 6 digits.');
        maxLengthMap[field.value] = 6;
        break;
      case 'ifsc':
        schemaFields[field.value] = yup.string().required('IFSC code is required').matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{11}$/, 'Invalid IFSC code format. Must be 11 alphanumeric digits.');
        maxLengthMap[field.value] = 11;
        break;
      case 'ifscNumber':
        schemaFields[field.value] = yup.string().required('IFSC code is required').matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{11}$/, 'Invalid IFSC code format. Must be 11 alphanumeric digits.');
        maxLengthMap[field.value] = 11;
        break;
      case 'accNumber':
        schemaFields[field.value] = yup.string().required('Account number is required').matches(/^[A-Za-z0-9]{5,20}$/,'Invalid bank account number format. Must be 5 to 20 alphanumeric characters.');
        maxLengthMap[field.value] = 20;
        break;
      case 'email':
        schemaFields[field.value] = yup
          .string()
          .required('Email is required')
          .max(254, 'Email is too long')
          .email('Invalid email format')
          .test('no-consecutive-dots', 'Email cannot contain consecutive dots', (value) => {
            return value ? !/\.{2,}/.test(value) : false;
          })
          .test('domain-dot-check', 'Email domain must contain a dot (e.g. example.com)', (value) => {
            if (!value) return false;
            const domain = value.split('@')[1]?.toLowerCase();
            return !!domain && domain.includes('.');
          })
          .test('valid-characters', 'Invalid characters in email', (value) => {
            return value
              ? /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/.test(value)
              : false;
          })
          .test('gmail-domain-check', 'Gmail must end with .com, .co, or .in', (value) => {
            if (!value) return false;
            const domain = value.split('@')[1]?.toLowerCase();
            if (!domain) return false;
      
            if (domain.startsWith('gmail.')) {
              return ['com', 'co', 'in'].some(tld => domain.endsWith(`.${tld}`));
            }
            return true;
          });
      
        maxLengthMap[field.value] = 254;
        break;
        case 'ip':
    schemaFields[field.value] = yup
      .string()
      .required('IP Address is required')
      .test('ip-format', 'Invalid IPv4 or IPv6 Address format', (value) => {
        if (typeof value !== 'string') return false;

      const trimmedValue = value.trim();
      if (trimmedValue === '') return false;

      const ipv4Pattern = /^(?!0)(?!.*\.$)((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.|$)){4}$/;

      const ipv6Pattern = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(::)|([0-9a-fA-F]{1,4}::[0-9a-fA-F]{1,4}))$/;

      return ipv4Pattern.test(trimmedValue) || ipv6Pattern.test(trimmedValue);
      });
    maxLengthMap[field.value] = 45;
    break;
      default:
        schemaFields[field.value] = yup.string().required(`Please enter ${field.label}`);
    }
  });

  return { schema: yup.object().shape(schemaFields), maxLengthMap };
};
